import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.less'],
  standalone: false
})
export class PageNotFoundComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  handleCustomerActivation() {
    this.router.navigate(['customerActivation']);
  }
  handleShareSvtLocation() {
    this.router.navigate(['ShareSvtLocation']);
  }
  handleDiagnosticPortal() {
    this.router.navigate(['pageNotFound']);
  }
  handleBuzzPortal() {
    this.router.navigate(['pageNotFound']);
  }

}
